export default [
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/Oolongswap.c4b06cf9.webp',
    name: 'OolongSwap',
    decription:
      'The leading DEX on Boba. OolongSwap incorporates all of the features you need from a traditional DEX while pioneering new ideas from DeFi 2.0 such as Protocol Controlled Value.',
    website: 'https://oolongswap.com/',
    telegram: 'https://t.me/oolongswap',
    twitter: 'https://twitter.com/oolongswap',
    discord: 'http://discord.gg/savwHHXsmU',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/frax.60c4ce16.webp',
    name: 'FRAX',
    decription: 'World’s first fractional-algorithmic stablecoin protocol.',
    website: 'https://frax.finance/',
    telegram: 'https://t.me/fraxfinance',
    twitter: 'https://twitter.com/fraxfinance',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/dominanaceFinanace.cb1c1a78.webp',
    name: 'Domination Finance',
    decription: 'The world’s first DEX for dominance trading.',
    website: 'https://domination.finance/',
    telegram: 'https://twitter.com/dominationfi',
    twitter: 'https://discord.domination.finance/',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/zencha.5f82c321.webp',
    name: 'Zencha',
    decription: 'The First StableSwap Exchange & Liquidity Pool on Boba.',
    website: 'https://www.zencha.finance/#/',
    telegram: 'https://t.me/zenchafinance',
    twitter: 'https://twitter.com/ZenchaFinance',
    discord: 'https://discord.com/invite/DwjPNvAwdd',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/unidex.2da67bf2.webp',
    name: 'Unidex',
    decription:
      'The meta-aggregator of everything in DeFi. Charts, perpetuals, swaps, limit-orders, data, and more everyday.',
    website: 'https://unidexbeta.app/trading',
    telegram: 'https://t.me/unidexfinance',
    twitter: 'https://twitter.com/UniDexFinance',
    discord: 'https://discord.com/invite/WzJPSjGj4h',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/deBank.d6e12678.webp',
    name: 'DeBank',
    decription: 'A leading DeFi portfolio tracker that supports a large number of DeFi protocols across 19 chains.',
    website: 'https://debank.com/',
    telegram: 'https://t.me/DeBankEN',
    twitter: 'https://twitter.com/DebankDeFi',
    discord: 'https://discordapp.com/invite/KYuj8DE',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/dodo.3ac394fb.webp',
    name: 'Dodo',
    decription: 'Decentralized Trading Protocol for Web3, Powered by Proactive Market Making.',
    website: 'https://dodoex.io/',
    telegram: 'https://twitter.com/BreederDodo',
    twitter: 'http://discord.gg/tyKReUK',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/thetanuts.d162f097.webp',
    name: 'Thetanuts',
    decription:
      'Sustainable yield through automated yield generating vault strategies implemented on cross-chain structured products.',
    website: 'https://thetanuts.finance/vaults',
    telegram: 'https://twitter.com/thetanuts',
    twitter: 'https://discord.gg/XnSYqutaB3',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/satis.a5b2cd8a.webp',
    name: 'Satis',
    decription:
      'The DEX for the Interoperable Future - First multichain order book derivatives DEX powered by concentrated liquidity.',
    website: 'https://boba-testnet.sat.is/',
    telegram: 'https://t.me/Satis_Channel',
    twitter: 'https://twitter.com/SatisDEX',
    discord: 'https://discord.gg/JUmcTGbUWr',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/brewery.5e13b748.svg',
    name: 'Boba Brewery',
    decription:
      'Boba Brewery is the first launchpad for decentralized fundraising in the Boba ecosystem, offering the hottest and innovative projects in a fair, secure, and efficient way.',
    website: 'http://bobabrewery.com/',
    telegram: 'https://t.me/bobabrewery',
    twitter: 'https://twitter.com/boba_brewery',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/bodhfinance.3c743a90.svg',
    name: 'Bodh Finance',
    decription: 'The leading Lending protocol on Boba Network.',
    website: 'https://bodh.finance/',
    telegram: 'https://twitter.com/BodhFinance',
    twitter: 'https://discord.gg/za9KXX5m6E',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/symbiosis.71642441.svg',
    name: 'Symbiosis',
    decription:
      'Symbiosis aggregates decentralized exchange liquidity across any EVM and non-EVM networks. Swap any token and transfer liquidity. Yes, any.',
    website: 'https://symbiosis.finance/',
    telegram: 'https://t.me/symbiosis_finance',
    twitter: 'https://twitter.com/symbiosis_fi',
    discord: 'https://discord.gg/vmQjR2d7WC',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/bobaPunks.4fa3ac59.webp',
    name: 'Boba Punks',
    decription: 'The first punks on Boba.',
    website: 'https://t.co/FRw0XfaQBH',
    telegram: 'https://t.me/bobapunks',
    twitter: 'https://twitter.com/boba_punks',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/tofuNft.6c3e3041.webp',
    name: 'tofuNFT',
    decription: 'NFT marketplace for Boba Network.',
    website: 'https://tofunft.com/',
    telegram: 'http://t.me/boringDAO',
    twitter: 'https://twitter.com/tofuNFT',
    discord: 'https://discord.gg/3wFUTZmTm7',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/bobaapes.4d3b2829.webp',
    name: 'Boba Apes',
    decription: 'Christmas collection of 10000 randomized and unique digital collectibles.',
    website: 'https://bobaapes.com/',
    telegram: 'https://twitter.com/bobaapes',
    twitter: '',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/shibuidao.4e62dfc7.svg',
    name: 'ShibuiNFT',
    decription: 'An NFT marketplace on Boba.',
    website: 'https://shibuinft.com/',
    telegram: 'https://docs.shibuidao.com/telegram',
    twitter: 'https://docs.shibuidao.com/twitter',
    discord: 'https://docs.shibuidao.com/discord',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/BoringDAO.e2e02856.webp',
    name: 'BoringDAO',
    decription:
      'Safely move your Bitcoin & other crypto assets between Ethereum and different blockchains to maximize utilization rate of crypto assets in DeFi world.',
    website: 'https://oportal.boringdao.com/twoway',
    telegram: 'https://t.me/Satis_Channel',
    twitter: 'https://twitter.com/TheBoringDAO',
    discord: 'https://discord.gg/4CezfPe7',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/Multichain.850d7c9b.webp',
    name: 'Multichain',
    decription: 'Cross-Chain Router Protocol, envisioned to be the ultimate router for Web3.',
    website: 'https://anyswap.exchange/#/dashboard',
    telegram: 'https://twitter.com/AnyswapNetwork',
    twitter: '',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/syn.b0480682.webp',
    name: 'Synapse',
    decription: 'A widely used cross-chain liquidity network connecting all blockchains.',
    website: 'https://synapseprotocol.com/?inputCurrency=USDC&outputCurrency=MIM&outputChain=42161',
    telegram: 'https://t.me/synapseprotocol',
    twitter: 'https://twitter.com/SynapseProtocol',
    discord: 'https://discord.com/invite/synapseprotocol',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/layerswap.b563fd71.webp',
    name: 'LayerSwap',
    decription: 'Bridge Crypto from CEX to Layer2 faster and cheaper.',
    website: 'https://www.layerswap.io/',
    telegram: 'https://twitter.com/layerswap',
    twitter: 'http://discord.gg/KhwYN35sHy',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/across.dc90564b.webp',
    name: 'Across',
    decription: 'Across is a fast, cheap, and secure bridge between L1 and L2s.',
    website: 'https://across.to/',
    telegram: 'https://twitter.com/AcrossProtocol',
    twitter: 'https://discord.gg/across',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/apeBoard.cd0d0211.webp',
    name: 'ApeBoard',
    decription: 'Multi-chain DeFi dashboard. Built by apes, for apes.',
    website: 'https://apeboard.finance/dashboard',
    telegram: 'https://t.me/joinchat/IgrzTnHKm-A0RwSP',
    twitter: 'https://twitter.com/ape_board',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/safepal.04895fc9.webp',
    name: 'SafePal',
    decription: '1st tokenized crypto hardware wallet.',
    website: 'https://safepal.io/',
    telegram: '',
    twitter: '',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/multiSig.8d28b051.svg',
    name: 'Boba MultiSig',
    decription: 'The most trusted platform to manage digital assets on Ethereum.',
    website: 'https://multisig.boba.network/',
    telegram: '',
    twitter: '',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/mew.197abb83.webp',
    name: 'MEW',
    decription: 'Free, client-side interface helping you interact with the Ethereum blockchain,',
    website: 'https://www.myetherwallet.com/',
    telegram: 'https://t.me/myetherwallet',
    twitter: 'https://twitter.com/myetherwallet',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/coin98.fc4e6fff.webp',
    name: 'Coin98',
    decription:
      'Leading multi-chain wallet and DeFi gateway, designed to seamlessly connect users to the crypto world in a safe and secure manner.',
    website: 'https://wallet.coin98.com/',
    telegram: 'https://t.me/myetherwallet',
    twitter: 'https://twitter.com/coin98_wallet',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/decentWallet.b0d09c87.webp',
    name: 'DICENT Wallet',
    decription: 'The �ber convenient multi crypto wallet with native dApp browser for Game, NFT, DeFi, and more.',
    website: 'https://dcentwallet.com/',
    telegram: 'https://twitter.com/DCENTwallets',
    twitter: '',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/defiyield.6c88d12f.webp',
    name: 'DEFIYIELD',
    decription: 'Manage Your DeFi Life. Asset Management Dashboard secured by a Blockchain Security Blockchain.',
    website: 'https://defiyield.app/dashboard',
    telegram: 'https://t.me/defiyield_app',
    twitter: 'https://twitter.com/defiyield_app',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/bandProtocol.8c41bf93.webp',
    name: 'Band Protocol',
    decription: 'Secure, scalable cross-chain decentralized oracle.',
    website: 'https://bandprotocol.com/',
    telegram: 'https://t.me/bandprotocol',
    twitter: 'https://twitter.com/BandProtocol',
    discord: 'https://discord.com/invite/3t4bsY7',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/l2Charts.f914f5c7.webp',
    name: 'L2Charts',
    decription: 'Your Favorite charts on L2.',
    website: 'https://l2charts.com/',
    telegram: 'https://twitter.com/L2Charts',
    twitter: '',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/umaprotocol.b18e70be.webp',
    name: 'UMA Protocol',
    decription: 'Optimistic Oracle built for Web3.',
    website: 'https://umaproject.org/',
    telegram: 'https://twitter.com/UMAprotocol',
    twitter: 'https://discord.com/invite/jsb9XQJ',
    discord: '',
  },
  {
    picture: 'https://gateway.rinkeby.boba.network/static/media/bobaDoge.df1abdd9.webp',
    name: 'Boba Doge',
    decription: 'The first dog coin on Boba.',
    website: 'https://thebobadoge.com/',
    telegram: 'https://t.me/thebobadoge',
    twitter: 'https://twitter.com/BobaDoge',
    discord: 'http://discord.gg/jvXBqpKgdt',
  },
];
